import { AdminCarrierTable } from '../views/index';
import { CarrierListAdmin } from '../dtos/index';
import { DATE_MDY } from '../../utils/date/date-parser';

export const ADMIN_CARRIER_LIST_TABLE = (
	carrierList: Array<CarrierListAdmin> = []
): Array<AdminCarrierTable> => {
	let results: Array<AdminCarrierTable> = [];
	if (carrierList.length > 0) {
		carrierList.map((carrier) => {
			let row = {} as AdminCarrierTable;
			row.business_name = carrier.carrierDTOResponse.businessName || '';
			row.carrierId = carrier.carrierDTOResponse.id;
			row.oldCarrierId = carrier.carrierDTOResponse.oldCarrierId || null;
			row.dot = carrier.carrierDTOResponse.dot || '';
			row.last_capacity_email_received_at =
				carrier.carrierDTOResponse.lastCapacityEmailReplySentAt || null;
			row.mc = carrier.carrierDTOResponse.mc || '';
			row.contactsCount = carrier.contactsCount;
			row.doingBusinessAs = carrier.carrierDTOResponse.doingBusinessAs;
			row.inNetwork = carrier.carrierDTOResponse.inNetwork;
			row.active = carrier.carrierDTOResponse.active;
			row.laneCount = carrier.carrierDTOResponse.laneCount;
			row.accountId = carrier.carrierDTOResponse.accountId;
			row.stageId = carrier.carrierDTOResponse.stageId;

			row.carrierRecruiterLastContacted = carrier?.carrierDTOResponse?.carrierRecruiterLastContacted
				? DATE_MDY(carrier.carrierDTOResponse.carrierRecruiterLastContacted)
				: '';
			row.carrierRecruiterNextContactDate = carrier?.carrierDTOResponse
				?.carrierRecruiterNextContactDate
				? DATE_MDY(carrier.carrierDTOResponse.carrierRecruiterNextContactDate)
				: '';
			row.carrierRecruiterContactedCount =
				carrier.carrierDTOResponse.carrierRecruiterContactedCount;
			results.push(row);
		});
	}
	return results;
};
